import { CHANNEL_LIST_SCREEN, MAIN_STACK } from '../../shared/Constants';
import React, { useCallback, useEffect } from 'react';

import { AUTH_STACK } from '../../../auth/Constants';
// @ts-ignore
import { Base64 } from 'js-base64';
import { KitLoader } from '@omni/kit/components';
import { View } from 'react-native';
import { savePendingCommandToDevice } from '../../utilities/mobileStorage';
import { useChatAuth } from '../../context/ChatAuthContext';

interface AcceptInvitationScreenProps {
  route: any;
  navigation: any;
}

export default function AcceptInvitationScreen({
  route,
  navigation,
}: AcceptInvitationScreenProps) {
  // Invite payload is a base64 encoded JSON which contains all info required to
  // accept an invite
  const invitePayload: string | undefined = route.params?.invitePayload;

  const { isAuthenticated, isReady: isAuthReady } = useChatAuth();

  const processInvite = useCallback(() => {
    if (!invitePayload) {
      return;
    }

    const decodedPayload = decodeURIComponent(invitePayload);
    const inviteObject = JSON.parse(Base64.decode(decodedPayload));
    savePendingCommandToDevice(inviteObject.moduleCommand);
    if (isAuthReady && !isAuthenticated) {
      navigation.navigate(AUTH_STACK);
    } else if (isAuthReady && isAuthenticated) {
      navigation.navigate(MAIN_STACK, { screen: CHANNEL_LIST_SCREEN });
    }
  }, [invitePayload, isAuthReady, isAuthenticated, navigation]);

  useEffect(() => {
    processInvite();
  }, [processInvite]);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <KitLoader />
    </View>
  );
}
